module.exports = __webpack_public_path__ + "img/logo.4581a4b1.png";